import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

/*
const theme = {
  primary: '#4cafa6',
  secondary: '#c26bbb',
  accent: '#08b7eb',
  info: '#4c81af',
}
*/
const theme = {
  primary: '#2EC4B6',
  secondary: '#c26bbb', /* '#603cba', */
  accent: '#FF9F1C',
  info: '#363636',
  warning: '#e83e66',
  action: '#aa6bcb',
}

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: localStorage.getItem('darkMode') == 'true' || false,
  },
})

